import { useEffect, useState } from "react";
import {
  DEFAULT_PUBLISHER_MEMBERSHIP_PRICE_INR,
  fetchPublicPublisherMembershipPrice,
  membershipPriceDigitsDataAttribute,
} from "../services/publicMembershipPrice";

export function MembershipPage() {
  const [amountDisplay, setAmountDisplay] = useState(
    String(DEFAULT_PUBLISHER_MEMBERSHIP_PRICE_INR),
  );
  const [amountInr, setAmountInr] = useState(DEFAULT_PUBLISHER_MEMBERSHIP_PRICE_INR);

  useEffect(() => {
    let cancelled = false;
    void fetchPublicPublisherMembershipPrice()
      .then((price) => {
        if (cancelled) {
          return;
        }
        setAmountDisplay(price.amountDisplay);
        setAmountInr(price.amountInr);
      })
      .catch(() => {
        // Keep approved ₹999 display if public pricing cannot be loaded.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const priceDigits = membershipPriceDigitsDataAttribute(amountInr);

  return (
    <article className="oac-membership-page">
      <div className="oac-membership-page__inner">
        <h1 className="oac-membership-page__heading">
          <span className="oac-membership-page__heading-desktop-only">
            Simple &amp; Transparent
          </span>
          <span className="oac-membership-page__heading-mobile-only">
            <span className="oac-membership-page__heading-mobile-line">
              Simple &amp;
            </span>
            <span className="oac-membership-page__heading-mobile-line">
              Transparent
            </span>
          </span>
        </h1>

        <p className="oac-membership-page__intro">
          <span className="oac-membership-page__intro-desktop-only">
            One simple membership. Everything you need to publish and manage
            your Android app.
          </span>
          <span className="oac-membership-page__intro-mobile-only">
            <span className="oac-membership-page__intro-mobile-line">
              One simple membership.
            </span>
            <span className="oac-membership-page__intro-mobile-line">
              Everything you need to publish and
            </span>
            <span className="oac-membership-page__intro-mobile-line">
              manage your Android app.
            </span>
          </span>
        </p>

        <div
          aria-label="OpenAppCart membership benefits"
          className="oac-membership-page__benefits"
        >
          <p className="oac-membership-page__benefit-row">
            <span>Publish your Android app</span>

            <span
              aria-hidden="true"
              className="oac-membership-page__separator"
            >
              |
            </span>

            <span>Update your app anytime.</span>
          </p>

          <p className="oac-membership-page__benefit-row">
            <span>Permanent Public App Pages</span>

            <span
              aria-hidden="true"
              className="oac-membership-page__separator"
            >
              |
            </span>

            <span>Publisher Dashboard</span>

            <span
              aria-hidden="true"
              className="oac-membership-page__separator"
            >
              |
            </span>

            <span>Your Own Payment Provider</span>
          </p>

          <p className="oac-membership-page__benefit-row">
            <span>Keep 100% of Your Revenue</span>

            <span
              aria-hidden="true"
              className="oac-membership-page__separator"
            >
              |
            </span>

            <span>Renew annually with 15% increase</span>
          </p>

          <p className="oac-membership-page__benefit-row">
            <span>Publish your app. Simply.</span>
          </p>
        </div>

        <div
          aria-label={`Membership price: ₹${amountDisplay} per app per year`}
          className="oac-membership-price"
          data-price-digits={priceDigits}
        >
          <div className="oac-membership-price__primary">
            <span className="oac-membership-price__currency">₹</span>

            <span className="oac-membership-price__amount">{amountDisplay}</span>
          </div>

          <span className="oac-membership-price__period">
            per app | per year
          </span>
        </div>
      </div>
    </article>
  );
}
